import { render, staticRenderFns } from "./CHECKBOXES.vue?vue&type=template&id=1ef2da6c&scoped=true&"
import script from "./CHECKBOXES.vue?vue&type=script&lang=js&"
export * from "./CHECKBOXES.vue?vue&type=script&lang=js&"
import style0 from "./CHECKBOXES.vue?vue&type=style&index=0&id=1ef2da6c&lang=scss&scoped=true&"
import style1 from "./CHECKBOXES.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef2da6c",
  null
  
)

export default component.exports